import React from 'react';
import { Link } from 'react-router-dom';
import cctvIMGg from '../../assets/cctvIMG.jpg';
import cctvImg from '../../assets/cctv.jpg';
import network from '../../assets/server3.jpg'
import sever from '../../assets/server5.jpg'

const Onsite =()=>{

    return(
        <section className='container mx-auto px-4 md:px-0 font-nunito mt-16'>
             <div className="relative">
                <img src={cctvIMGg} alt="Slide 3" className="w-full h-64 md:h-80 lg:h-96 object-cover" />
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <h2 className="text-white text-4xl lg:text-6xl font-bold text-center">On Site Engineer </h2>
                </div>
            </div>
            <div className="flex flex-col md:flex-row items-center mt-8">
                <img src={cctvImg} alt="About Us" className="w-full md:w-1/2 md:mt-0 object-cover" /> <br />
                <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                    <h1 className='font-bold text-center text-justify lg:text-4xl'>On Site Engineer</h1>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    Our comprehensive advisory and consulting services are integral to every engagement, providing high-level support both on-premises and in the cloud. Many businesses neglect their servers, data, and networks for extended periods, leaving their IT infrastructure vulnerable. Avoid these risks by allowing us to manage your systems, ensuring continuous business operation
                    </p>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    Our dedicated technical resources are available full-time at your site to handle daily IT operations. These on-site experts have access to IBS’s talent pool, ensuring the right skills are deployed at the right time
                    </p>
                </div>
            </div> 
            <br />
                <hr />
            <br />
            <div className="flex flex-col md:flex-row items-center mt-8">
                <img src={network} alt="cctv" className="w-full md:w-1/3 md:mt-0 object-cover text-justify" /> <br />
                <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                    <h1 className='font-bold text-center text-justify lg:text-4xl'>Server Setups and Upgrades</h1>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    Our server experts are online 24/7 to help you take care of complex server tasks or rescue your server from critical issues. That’s not all. We monitor, audit and secure your server so that you can get the best performance and uptime for your server
                    </p>
                </div>
            </div> 
            <div className="flex flex-col md:flex-row items-center mt-8">
                <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                    <h1 className='font-bold text-center text-justify lg:text-4xl'>Network Support & Maintenance </h1>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    Despite the difficulties that come with technology management, maintenance is a vital role that must be fulfilled in order to get the most from your hardware and software. Our proactive Remote Monitoring and Maintenance support is designed to remediate these issues for small and medium-sized businesses, and make them more affordable than ever before. Protect your investment and maximize uptime with our support.
                    </p>
                </div>
                <img src={sever} alt="cctv" className="w-full md:w-1/3 md:mt-0 object-cover text-justify" />
            </div> <br />
            <hr /><br />
            <div className="flex flex-col justify-center items-center space-y-4">
                <h1 className="font-bold text-center lg:text-4xl">
                We give you the right skillset involvement on right time!
                </h1>
                <div>
                <div>
                    <button className="rounded bg-blue-900 py-2 px-4 font-bold text-[#d4af37] transition-transform duration-300 hover:scale-110 hover:bg-[#013751]">
                      <Link to={'/ContactPage'}> Talk to Us</Link> 
                    </button>
                </div>
                </div>
            </div>
            </section>
           
        )
}
export default Onsite;